import { isMobileSSR, isLoggedInSSR } from 'factory/utils/serverUtils';
import { useRouter } from 'next/router';
// store import
import { isLogedInAction } from 'factory/store/actions/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageLayout from 'components/Assets/Layouts/PageLayout';

import { useEffect } from 'react';
import { singleLineHeader } from 'components/common/header/SingleLineHeader/action';
import { footerAction } from 'components/common/footer/SingleLineFooter/action';
import ReferEarnPage from 'components/ReferAndEarn/ReferEarnPage';
const ReferAndEarn = ({ show404 = false, isMobile, serverIsLoggedin, _isLogedInAction, ...props }) => {
    const _pageType = 'ReferAndEarn';
    const router = useRouter();
    useEffect(() => {
        props._singleLineHeader(false);
        props._footerAction(true);
        if (serverIsLoggedin) {
            _isLogedInAction(serverIsLoggedin);
        }
    }, []);

    return (
        <>
            {
                isMobile ?
                    <PageLayout
                        {...props}
                        show404={show404}
                        isMobile={isMobile}
                        pageType={_pageType}
                        router={router}
                        noHeader={true}
                        hideFooter={true}
                    >
                        <ReferEarnPage
                            key={props.uniId}
                            pageType={_pageType}
                            isMobile={isMobile}
                            isLoggedIn={serverIsLoggedin}
                        />
                    </PageLayout>
                    :
                    <PageLayout
                        {...props}
                        show404={show404}
                        isMobile={isMobile}
                        pageType={_pageType}
                        router={router}
                    >
                        <ReferEarnPage
                            key={props.uniId}
                            pageType={_pageType}
                            isMobile={isMobile}
                            isLoggedIn={serverIsLoggedin}
                        />
                    </PageLayout>
            }
        </>
    );
};

export async function getServerSideProps({ req }) {
    let isMobile = isMobileSSR(req);
    let serverIsLoggedin = isLoggedInSSR(req);

    return { props: { isMobile, serverIsLoggedin, uniId: new Date().getTime() } };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        _isLogedInAction: isLogedInAction,
        _singleLineHeader: singleLineHeader,
        _footerAction: footerAction,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ReferAndEarn);